import { parseCantidadPendientes } from '../data/materiasPendientes';

const PENDING_FIELDS = ['pendientes4to', 'pendientes5to', 'pendientes6to'];
const UNKNOWN_VALUES = ['No recuerdo exactamente', 'No lo recuerdo exactamente'];
const ELIGIBLE_UTU_ORIENTATIONS = [
  'deporte y recreacion',
  'deportes y recreacion',
  'administracion',
  'informatica'
];

const normalizeValue = (value = '') => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLowerCase();

export const calculateAge = (birthDate, today = new Date()) => {
  if (!birthDate) return NaN;
  const [year, month, day] = birthDate.split('-').map(Number);
  if (!year || !month || !day) return NaN;

  let age = today.getFullYear() - year;
  if (new Date(today.getFullYear(), month - 1, day) > today) age -= 1;
  return age;
};

export const isEligibleUtuOrientation = (orientation) =>
  ELIGIBLE_UTU_ORIENTATIONS.includes(normalizeValue(orientation));

export const calculatePendingTotal = (formData) => PENDING_FIELDS
  .map((field) => parseCantidadPendientes(formData[field]))
  .reduce((total, current) => total + current, 0);

export const getEndingCase = (formData, today = new Date()) => {
  const age = calculateAge(formData.nacimiento, today);
  if (!Number.isNaN(age) && age >= 30) return 4;
  if (!Number.isNaN(age) && age <= 17) return 5;

  if (formData.tipoInstitucion === 'Privado') return 6;
  if (formData.tipoCentro === 'UTU' && formData.bachillerato && !isEligibleUtuOrientation(formData.bachillerato)) {
    return 9;
  }

  const pendingValues = PENDING_FIELDS.map((field) => formData[field]);
  if (!pendingValues.every(Boolean)) return null;
  if (pendingValues.some((value) => UNKNOWN_VALUES.includes(value))) return 3;
  if (pendingValues.every((value) => value === '0')) return 7;

  const [pending4to, pending5to, pending6to] = pendingValues.map(parseCantidadPendientes);
  const total = pending4to + pending5to + pending6to;

  if (formData.tipoCentro === 'UTU') {
    if (total >= 5) return 8;
    if (total >= 1 && total <= 4) return 1;
    return null;
  }

  if (formData.tipoCentro === 'Liceo') {
    if (total >= 6 || pending4to >= 2 || pending5to >= 4 || pending6to >= 6) return 2;
    if (total >= 1 && total <= 5) return 1;
  }

  return null;
};
